import { ReactElement, useEffect, useState } from 'react';

import PrivacySettings from 'components/GDPRPopup/PrivacySettings/PrivacySettings';

import { getGDPRSettings } from 'utils/localStorage';

import { RESET_PASSWORD } from 'constants/path';

import styles from './GDPRPopup.module.scss';

const EXCLUDED_PATHS = [RESET_PASSWORD];

const GDPRPopup = (): ReactElement | null => {
  const [isGDPRVisible, setIsGDPRVisible] = useState(!getGDPRSettings());

  const isPathExcluded = EXCLUDED_PATHS.includes(window.location.pathname);

  useEffect(() => {
    const settings = getGDPRSettings();
    if (!settings) {
      setIsGDPRVisible(true);
    }
  }, []);

  if (!isGDPRVisible || isPathExcluded) return null;

  return (
    <div className={styles.popupContainer}>
      <PrivacySettings
        setVisible={setIsGDPRVisible}
        setGDPR={setIsGDPRVisible}
      />
    </div>
  );
};

export default GDPRPopup;
